import React from 'react'
import Helmet from 'react-helmet'

const EvilPage = ({
  data
}) => {
  if (data.contentfulEvilPage) {
  const title = data && data.contentfulEvilPage && data.contentfulEvilPage.title ? data.contentfulEvilPage.title : null;
  const description = data && data.contentfulEvilPage && data.contentfulEvilPage.description && data.contentfulEvilPage.description.description ? data.contentfulEvilPage.description.description : null;
  const body = data && data.contentfulEvilPage && data.contentfulEvilPage.body && data.contentfulEvilPage.body.body ? data.contentfulEvilPage.body.body : null;

  return(
  <div>
    <Helmet>
      <meta charset='utf-8' />
      <meta http-equiv='X-UA-Compatible' content='IE=edge' />
      <meta name='viewport' content='width=device-width, initial-scale=1.0' />
      <title>{title}</title>
      <meta
        name='description'
        content={description}
      />
      <meta
        name='google-site-verification'
        content='TZB0CK0qYKk4Effi3SbiGz86dZSwbzVqWdbq2d4UBes'
      />
      <link
        rel='stylesheet'
        type='text/css'
        href='/main.css'
      />
      <link
        rel='stylesheet'
        href='https://unpkg.com/tachyons@4.9.1/css/tachyons.min.css'
      />
      <link
        rel='stylesheet'
        type='text/css'
        href='//cdnjs.cloudflare.com/ajax/libs/highlight.js/8.4/styles/default.min.css'
      />
      <link
        rel='icon'
        type='image/png'
        href='/images/favicon-16x16.png'
        sizes='16x16'
      />
      <link
        rel='icon'
        type='image/png'
        href='/images/favicon-96x96.png'
        sizes='96x96'
      />
      <link
        rel='icon'
        type='image/png'
        href='/images/favicon-32x32.png'
        sizes='32x32'
      />
      <meta
        itemprop='name'
        content={title}
      />
      <meta
        itemprop='description'
        content={description}
      />
      <meta
        name='twitter:site'
        content='@Rangleio'
      />
      <meta
        name='twitter:title'
        content={title}
      />
      <meta
        name='twitter:description'
        content={description}
       />
      <meta
        property='og:title'
        content={title}
      />
      <meta
        property='og:description'
        content={description}
      />
      <script>{`
        (function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
        (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
        m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
        })(window,document,'script','https://www.google-analytics.com/analytics.js','ga');
        ga('create', 'UA-41067508-1', 'auto');
        ga('require', 'GTM-K8ZHV9G');
        ga('send','pageview');
      `}</script>
      <script type='text/javascript' id='inspectletjs'>{`
        window.__insp = window.__insp || [];
        __insp.push(['wid', 307955191]);
        (function() {
          function ldinsp() {
            if (typeof window.__inspld != "undefined") return;
            window.__inspld = 1;
            var insp = document.createElement('script');
            insp.type = 'text/javascript';
            insp.async = true;
            insp.id = "inspsync";
            insp.src = (
              'https:' == document.location.protocol ? 'https' : 'http'
            ) + '://cdn.inspectlet.com/inspectlet.js';
            var x = document.getElementsByTagName('script')[0];
            x.parentNode.insertBefore(insp, x);
          };
          setTimeout(ldinsp, 500);
          document.readyState != "complete" ? (
            window.attachEvent ? window.attachEvent(
              'onload', ldinsp
            ) : window.addEventListener('load', ldinsp, false)
          ) : ldinsp();
        })();
      `}</script>
      <script type='text/javascript'>{`
        (function() {
          vtid = 110120;
          var a = document.createElement('script');
          a.async = true;
          a.src = (
            'https:' == document.location.protocol ? 'https://' : 'http://'
          ) +
            'code.visitor-track.com/VisitorTrack2.js';
          var s = document.getElementsByTagName('script')[0];
          s.parentNode.insertBefore(a, s);
        })();
      `}</script>
      <script>{`
        !function(f, b, e, v, n, t, s) {
         if (f.fbq) return;
         n = f.fbq = function() {
           n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
         };
         if (!f._fbq) f._fbq = n;
         n.push = n;
         n.loaded = !0;
         n.version = '2.0';
         n.queue = [];
         t = b.createElement(e);
         t.async = !0;
         t.src = v;
         s = b.getElementsByTagName(e)[0];
         s.parentNode.insertBefore(t, s)
         }(
           window,
           document,
           'script',
           'https://connect.facebook.net/en_US/fbevents.js'
         );
         fbq('init', '449132735282640');
         fbq('track', 'PageView');
      `}</script>
      <noscript>{`
        <img
          height="1"
          width="1"
          style="display:none"
          src="https://www.facebook.com/tr?id=449132735282640&ev=PageView&noscript=1"
        />
      `}</noscript>
      <script type='text/javascript'>{`
        piAId = '214152';
        piCId = '1096';
        (function() {
          function async_load() {
            var s = document.createElement('script');
            s.type = 'text/javascript';
            s.src = (
              'https:' == document.location.protocol ?
              'https://pi' : 'http://cdn'
            ) + '.pardot.com/pd.js';
            var c = document.getElementsByTagName('script')[0];
            c.parentNode.insertBefore(s, c);
          }
          if (window.attachEvent) {
            window.attachEvent('onload', async_load);
          } else {
            window.addEventListener('load', async_load, false);
          }
        })();
      `}</script>
      <script type='text/javascript'>{`
        _linkedin_data_partner_id = "34040";
      `}</script>
      <script type='text/javascript'>{`
        (function() {
          var s = document.getElementsByTagName("script")[0];
          var b = document.createElement("script");
          b.type = "text/javascript";
          b.async = true;
          b.src = "https://snap.licdn.com/li.lms-analytics/insight.min.js";
          s.parentNode.insertBefore(b, s);
        })();
      `}</script>
      <script type='text/javascript'>{`
        window.heap=window.heap||[],heap.load=function(e,t){window.heap.appid=e,window.heap.config=t=t||{};var r=t.forceSSL||"https:"===document.location.protocol,a=document.createElement("script");a.type="text/javascript",a.async=!0,a.src=(r?"https:":"http:")+"//cdn.heapanalytics.com/js/heap-"+e+".js";var n=document.getElementsByTagName("script")[0];n.parentNode.insertBefore(a,n);for(var o=function(e){return function(){heap.push([e].concat(Array.prototype.slice.call(arguments,0)))}},p=["addEventProperties","addUserProperties","clearEventProperties","identify","resetIdentity","removeEventProperty","setEventProperties","track","unsetEventProperty"],c=0;c<p.length;c++)heap[p[c]]=o(p[c])};
        heap.load("2222639616");
      `}</script>
    </Helmet>
    <div
      dangerouslySetInnerHTML={{
        __html: body
      }}
    />
  </div>
  )
  } else {
    console.log('EvilPage data error: ', JSON.stringify(data));
    console.log('EvilPage data error!');
    return false;
  }
}

export const query = graphql`
  query EvilPageQuery($slug: String) {
    contentfulEvilPage(slug: { eq: $slug }) {
      slug,
      title,
      description {
        description
      },
      body {
        body
      }
    }
  }
`

export default EvilPage



// WEBPACK FOOTER //
// ./src/templates/evil-page.js